import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { OpenEstimateComponent } from '../open-estimate/open-estimate.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-search-estimate-dialog',
  templateUrl: './search-estimate-dialog.component.html',
  styleUrl: './search-estimate-dialog.component.scss',
  imports: [
    MatDialogModule, 
    MatButtonModule, 
    MatDialogTitle,
    OpenEstimateComponent,
    TranslatePipe
  ]
})
export class SearchEstimateDialogComponent {
  constructor(private readonly dialogRef: MatDialogRef<SearchEstimateDialogComponent>) {}

  closeDialog(estimateId: string): void {
    this.dialogRef.close(estimateId);
  }

  cancelDialog():void{
    this.dialogRef.close();
  }
}
